import { useState } from "react";
import { Formik, Form as FormikForm } from "formik";
import Form from "react-bootstrap/Form";
import * as yup from "yup";
import axios from "axios";
import InputGroup from "react-bootstrap/InputGroup";
import { useApiContext } from "../../context/ApiContext";
import DeleteBtnModal from "../../components/DeleteBtnModal";
import ManageBalanceTable from "./ManageBalanceTable";

const initialValues = {
  name: "",
  acc_status: "",
  acc_type: "",
  acc_number: "",
};

const schema = yup.object().shape({
  name: yup.string().required("Name is a required field!"),
  acc_status: yup.string(),
  acc_type: yup.string().required("Account Type is a required field!"),
  acc_number: yup.string().required("Account Number is a required field!"),
});

const validate = (values) => {
  let errors = {};

  if (values.acc_type === "bank") {
    if (!values.acc_number) {
      errors.acc_number = "Bank Account Number is required!";
    } else if (/^[0-9\b]+$/.test(values.acc_number) === false) {
      errors.acc_number = "Only number!";
    } else if (values.acc_number.length !== 13) {
      errors.acc_number = "Bank Account Number contains 13 digit!";
    }
  }

  if (values.acc_type === "bkash") {
    if (!values.acc_number) {
      errors.acc_number = "Bkash Number is required!";
    } else if (/^[0-9\b]+$/.test(values.acc_number) === false) {
      errors.acc_number = "Only number!";
    } else if (values.acc_number.length !== 11) {
      errors.acc_number = "Bkash Number contains 11 digit!";
    }
  }

  if (values.acc_type === "nagad") {
    if (!values.acc_number) {
      errors.acc_number = "Nagad Number is required!";
    } else if (/^[0-9\b]+$/.test(values.acc_number) === false) {
      errors.acc_number = "Only number!";
    } else if (values.acc_number.length !== 11) {
      errors.acc_number = "Nagad Number contains 11 digit!";
    }
  }

  return errors;
};

const ManageBalance = () => {
  const { unpaginate_manage_balance } = useApiContext();

  const [message, setMessage] = useState();
  const [item, setItem] = useState({});

  const AddManageBalanceFunc = async (values) => {
    let formfield = new FormData();

    formfield.append("name", values.name);
    formfield.append("acc_status", values.acc_status);
    formfield.append("acc_type", values.acc_type);
    formfield.append("acc_number", values.acc_number);

    await axios({
      method: "POST",
      url: `${process.env.REACT_APP_BASE_URL}${process.env.REACT_APP_UNP_MANAGE_BALANCE_URL}`,
      data: formfield,
    })
      .then((response) => {
        setMessage(
          response.success,
          "Manage Balance is successfuly created..."
        );
        window.location.reload(false);
      })
      .catch((error) => {
        setMessage(error.message, "Error");
      });
  };

  const submitAddManageBalanceForm = async (
    values,
    { setErrors, setSubmitting, resetForm }
  ) => {
    try {
      AddManageBalanceFunc(values);
      setSubmitting(false);
      // resetForm();
    } catch (error) {
      setErrors({ error: error.message });
    }
  };

  const updatedValues = {
    name: item.name ? item.name : "",
    acc_status: item.acc_status ? item.acc_status : "",
    acc_type: item.acc_type ? item.acc_type : "",
    acc_number: item.acc_number ? item.acc_number : "",
  };

  const UpdateManageBalanceFunc = async (values) => {
    let formfield = new FormData();

    formfield.append("name", values.name);
    formfield.append("acc_status", values.acc_status);
    formfield.append("acc_type", values.acc_type);
    formfield.append("acc_number", values.acc_number);

    await axios({
      method: "PUT",
      url: `${process.env.REACT_APP_BASE_URL}${process.env.REACT_APP_UNP_MANAGE_BALANCE_URL}${item.id}/`,
      data: formfield,
    })
      .then((response) => {
        setMessage(
          response.success,
          "Manage Balance is successfully updated..."
        );
        window.location.reload(false);
      })
      .catch((error) => {
        setMessage(error.message, "Error");
      });
  };

  const submitUpdateManageBalanceForm = async (
    values,
    { setErrors, setSubmitting }
  ) => {
    try {
      UpdateManageBalanceFunc(values);
      setSubmitting(false);
    } catch (error) {
      setErrors({ err: error.message });
    }
  };

  const updateManageBalance = async (id) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}${process.env.REACT_APP_UNP_MANAGE_BALANCE_URL}${id}/`
    );
    setItem(data);
  };

  return (
    <>
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-6">
                <div className="mx-3 my-2 page-title-box d-sm-flex align-items-center justify-content-start">
                  <h4 className="mb-sm-0">Manage Balance</h4>
                </div>
              </div>

              <div className="col-6">
                <div className="d-flex mx-3 my-2  align-items-center justify-content-end">
                  <button
                    className="btn btn-secondary mb-4"
                    data-bs-toggle="modal"
                    data-bs-target="#ManageBalanceAddModal"
                  >
                    <i className="bi bi-plus-circle align-baseline me-1"></i>{" "}
                    Add Manage Balance
                  </button>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-body">
                    <div className="table-responsive">
                      <ManageBalanceTable
                        unpaginate_manage_balance={unpaginate_manage_balance}
                        updateManageBalance={updateManageBalance}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <!--Add Modal --> */}
      <div
        className="modal fade"
        id="ManageBalanceAddModal"
        tabIndex="-1"
        aria-labelledby="ManageBalanceAddModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <Formik
              initialValues={initialValues}
              validationSchema={schema}
              onSubmit={submitAddManageBalanceForm}
              validate={validate}
            >
              {({
                handleSubmit,
                handleChange,
                values,
                touched,
                errors,
                isSubmitting,
              }) => (
                <FormikForm noValidate onSubmit={(e) => handleSubmit(e)}>
                  <div className="modal-header">
                    <h5 className="modal-title" id="ManageBalanceAddModalLabel">
                      Add Manage Balance
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      id="close-addAgentModal"
                    ></button>
                  </div>

                  <div className="modal-body">
                    <Form.Group className="form-outline mb-4">
                      <Form.Label>
                        Name<span>*</span>
                      </Form.Label>
                      <InputGroup hasValidation>
                        {/* <InputGroup.Text>@</InputGroup.Text> */}
                        <Form.Control
                          type="text"
                          name="name"
                          id="name"
                          value={values.name}
                          onChange={handleChange}
                          isInvalid={!!touched.name && !!errors.name}
                          isValid={touched.name && !errors.name}
                          className="form-control"
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.name}
                        </Form.Control.Feedback>
                      </InputGroup>
                    </Form.Group>

                    <Form.Group className="form-outline mb-4">
                      <Form.Label>
                        Status<span></span>
                      </Form.Label>
                      <InputGroup hasValidation>
                        {/* <InputGroup.Text>@</InputGroup.Text> */}
                        <Form.Select
                          name="acc_status"
                          id="acc_status"
                          value={values.acc_status}
                          onChange={handleChange}
                          isInvalid={
                            !!touched.acc_status && !!errors.acc_status
                          }
                          isValid={touched.acc_status && !errors.acc_status}
                          className="form-control"
                        >
                          <option value="">Select</option>
                          <option value={`${true}`}>Active</option>
                          <option value={`${false}`}>Inactive</option>
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          {errors.acc_status}
                        </Form.Control.Feedback>
                      </InputGroup>
                    </Form.Group>

                    <Form.Group className="form-outline mb-4">
                      <Form.Label>
                        Account Type<span>*</span>
                      </Form.Label>
                      <InputGroup hasValidation>
                        {/* <InputGroup.Text>@</InputGroup.Text> */}
                        <Form.Select
                          name="acc_type"
                          id="acc_type"
                          value={values.acc_type}
                          onChange={handleChange}
                          isInvalid={!!touched.acc_type && !!errors.acc_type}
                          isValid={touched.acc_type && !errors.acc_type}
                          className="form-control"
                        >
                          <option value="">Select</option>
                          <option value={`bank`}>Bank</option>
                          <option value={`bkash`}>Bkash</option>
                          <option value={`nagad`}>Nagad</option>
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          {errors.acc_type}
                        </Form.Control.Feedback>
                      </InputGroup>
                    </Form.Group>

                    <Form.Group className="form-outline mb-4">
                      <Form.Label>
                        Account Number<span>*</span>
                      </Form.Label>
                      <InputGroup hasValidation>
                        {/* <InputGroup.Text>@</InputGroup.Text> */}
                        <Form.Control
                          type="text"
                          name="acc_number"
                          id="acc_number"
                          value={values.acc_number}
                          onChange={handleChange}
                          isInvalid={
                            !!touched.acc_number && !!errors.acc_number
                          }
                          isValid={touched.acc_number && !errors.acc_number}
                          className="form-control"
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.acc_number}
                        </Form.Control.Feedback>
                      </InputGroup>
                    </Form.Group>
                  </div>

                  <div className="modal-footer">
                    <div className="hstack gap-2 justify-content-end">
                      <button type="reset" className="btn btn-danger">
                        Cancel
                      </button>

                      <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={isSubmitting}
                      >
                        Add
                      </button>
                    </div>
                  </div>

                  {/* message  */}
                  {message && <h2 className="text-center m-5">{message}</h2>}
                </FormikForm>
              )}
            </Formik>
          </div>
        </div>
      </div>

      {/* update Modal */}
      <div
        className="modal fade"
        id="ManageBalanceUpdateModal"
        tabIndex="-1"
        aria-labelledby="ManageBalanceUpdateModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <Formik
              enableReinitialize={true}
              initialValues={updatedValues}
              validationSchema={schema}
              onSubmit={submitUpdateManageBalanceForm}
              validate={validate}
            >
              {({
                handleSubmit,
                handleChange,
                values,
                touched,
                errors,
                isSubmitting,
              }) => (
                <FormikForm noValidate onSubmit={(e) => handleSubmit(e)}>
                  <div className="modal-header">
                    <h5
                      className="modal-title"
                      id="ManageBalanceUpdateModalLabel"
                    >
                      Update Manage Balance
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      id="close-addAgentModal"
                    ></button>
                  </div>

                  <div className="modal-body">
                    <Form.Group className="form-outline mb-4">
                      <Form.Label>
                        Name<span>*</span>
                      </Form.Label>
                      <InputGroup hasValidation>
                        {/* <InputGroup.Text>@</InputGroup.Text> */}
                        <Form.Control
                          type="text"
                          name="name"
                          id="name"
                          value={values.name}
                          onChange={handleChange}
                          isInvalid={!!touched.name && !!errors.name}
                          isValid={touched.name && !errors.name}
                          className="form-control"
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.name}
                        </Form.Control.Feedback>
                      </InputGroup>
                    </Form.Group>

                    <Form.Group className="form-outline mb-4">
                      <Form.Label>
                        Status<span></span>
                      </Form.Label>
                      <InputGroup hasValidation>
                        {/* <InputGroup.Text>@</InputGroup.Text> */}
                        <Form.Select
                          name="acc_status"
                          id="acc_status"
                          value={values.acc_status}
                          onChange={handleChange}
                          isInvalid={
                            !!touched.acc_status && !!errors.acc_status
                          }
                          isValid={touched.acc_status && !errors.acc_status}
                          className="form-control"
                        >
                          <option value="">Select</option>
                          <option value={`${true}`}>Active</option>
                          <option value={`${false}`}>Inactive</option>
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          {errors.acc_status}
                        </Form.Control.Feedback>
                      </InputGroup>
                    </Form.Group>

                    <Form.Group className="form-outline mb-4">
                      <Form.Label>
                        Account Type<span>*</span>
                      </Form.Label>
                      <InputGroup hasValidation>
                        {/* <InputGroup.Text>@</InputGroup.Text> */}
                        <Form.Select
                          name="acc_type"
                          id="acc_type"
                          value={values.acc_type}
                          onChange={handleChange}
                          isInvalid={!!touched.acc_type && !!errors.acc_type}
                          isValid={touched.acc_type && !errors.acc_type}
                          className="form-control"
                        >
                          <option value="">Select</option>
                          <option value={`bank`}>Bank</option>
                          <option value={`bkash`}>Bkash</option>
                          <option value={`nagad`}>nagad</option>
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          {errors.acc_type}
                        </Form.Control.Feedback>
                      </InputGroup>
                    </Form.Group>

                    <Form.Group className="form-outline mb-4">
                      <Form.Label>
                        Account Number<span>*</span>
                      </Form.Label>
                      <InputGroup hasValidation>
                        {/* <InputGroup.Text>@</InputGroup.Text> */}
                        <Form.Control
                          type="text"
                          name="acc_number"
                          id="acc_number"
                          value={values.acc_number}
                          onChange={handleChange}
                          isInvalid={
                            !!touched.acc_number && !!errors.acc_number
                          }
                          isValid={touched.acc_number && !errors.acc_number}
                          className="form-control"
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.acc_number}
                        </Form.Control.Feedback>
                      </InputGroup>
                    </Form.Group>
                  </div>

                  <div className="modal-footer">
                    <div className="hstack gap-2 justify-content-end">
                      <button type="reset" className="btn btn-danger">
                        Cancel
                      </button>

                      <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={isSubmitting}
                      >
                        Update
                      </button>
                    </div>
                  </div>

                  {/* message  */}
                  {message && <h2 className="text-center m-5">{message}</h2>}
                </FormikForm>
              )}
            </Formik>
          </div>
        </div>
      </div>

      <DeleteBtnModal id={`ManageBalanceDeleteModal`} />
    </>
  );
};

export default ManageBalance;
